export const componentKeys = {
    projectComponents: 'components/byProject',
    testCaseComponents: 'components/byTestCase',
    searchComponent: 'components/search',
};
